import { defineStore } from 'pinia'
import { ref } from 'vue'
import axiosInstance from '@/helpers/axios'
import { SwalSuccess, SwalError, SwalDelete } from '@/helpers/mySwal'

export const useAreaStore = defineStore('area', () => {
  const areas = ref([])
  const area = ref({})
  const loading = ref(false)
  const isLoaded = ref(false)
  const isLoadedOne = ref(false)

  const getAllAreas = async () => {
    if (loading.value) {
      await new Promise((resolve) => setTimeout(resolve, 1000))
      await getAllAreas()
    } else if (!isLoaded.value) {
      await readAllAreas()
    }
  }

  const readAllAreas = async () => {
    loading.value = true
    try {
      const { data } = await axiosInstance.get('/api/areas')
      areas.value = data
      isLoaded.value = true
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'טעינת אזורים נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const getOneArea = async (id) => {
    loading.value = true
    try {
      const { data } = await axiosInstance.get(`/api/areas/${id}`)
      area.value = data
      isLoadedOne.value = true
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'טעינת אזור נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const createArea = async (data) => {
    loading.value = true
    try {
      const { data: area } = await axiosInstance.post('/api/areas', data)
      if (isLoaded.value) {
        areas.value.push(area)
      }

      SwalSuccess.fire({
        title: 'אזור חדש נוצר בהצלחה'
      })

      return area.id
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'הוספת אזור נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const updateArea = async (data) => {
    loading.value = true
    try {
      const { data: updatedArea } = await axiosInstance.put(`/api/areas/${data.id}`, data)

      if (isLoaded.value) {
        areas.value = areas.value.map((area) => (area.id === data.id ? updatedArea : area))
      }

      if (isLoadedOne.value) {
        area.value = updatedArea
      }

      SwalSuccess.fire({
        title: 'פרטי האזור עודכנו בהצלחה'
      })
      return updatedArea.id
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'עדכון אזור נכשל'
      })
    } finally {
      loading.value = false
    }
  }

  const deleteArea = async (id) => {
    loading.value = true
    try {
      await axiosInstance.delete(`/api/areas/${id}`)
      if (isLoaded.value) {
        areas.value = areas.value.filter((area) => area.id !== id)
      }

      SwalSuccess.fire({
        title: 'פרטי האזור נמחקו בהצלחה'
      })
    } catch (error) {
      console.error(error)
      SwalError.fire({
        title: 'מחיקת אזור נכשלה'
      })
    } finally {
      loading.value = false
    }
  }

  const confirmDelete = async (id) => {
    const confirm = await SwalDelete.fire({
      text: `האם אתה בטוח שברצונך למחוק את האזור?`
    })

    if (confirm.isConfirmed) {
      await deleteArea(id)
    }
  }

  const $reset = () => {
    areas.value = []
    area.value = {}
    loading.value = false
    isLoaded.value = false
    isLoadedOne.value = false
  }

  return {
    areas,
    area,
    loading,
    isLoaded,
    isLoadedOne,
    getAllAreas,
    getOneArea,
    createArea,
    updateArea,
    deleteArea,
    confirmDelete,
    $reset
  }
})
